/**
 * Unified Product Image Slider
 * Handles product card image sliding functionality consistently across all sections
 */
document.addEventListener('DOMContentLoaded', function() {
  var sliderContainers = document.querySelectorAll('.product-card-slider-enabled');
  
  sliderContainers.forEach(function(container) {
    var images = container.querySelectorAll('.product-slider-image');
    var placeholders = container.querySelectorAll('.product-slider-image-placeholder');
    var allSlides = Array.from(images).concat(Array.from(placeholders));
    var prevBtn = container.querySelector('.slider-prev');
    var nextBtn = container.querySelector('.slider-next');
    var currentSlide = 0;
    var isTransitioning = false;
    
    // Initialize - check if any image is already active, otherwise use first
    var hasActiveImage = container.querySelector('.product-slider-image.active');
    if (allSlides.length > 0 && images.length > 0 && !hasActiveImage) {
      images[0].classList.add('active');
    }
    
    // Set current slide index based on active image
    if (hasActiveImage) {
      // Find the index of the active image in our allSlides array
      for (var i = 0; i < allSlides.length; i++) {
        if (allSlides[i] === hasActiveImage || 
            (allSlides[i].loadedImage && allSlides[i].loadedImage === hasActiveImage)) {
          currentSlide = i;
          break;
        }
      }
    }
    
    // Image loading function with error handling and smooth transitions
    function loadImage(placeholder) {
      if (placeholder.dataset.loaded) return Promise.resolve(placeholder.loadedImage);
      
      return new Promise(function(resolve, reject) {
        placeholder.classList.add('loading');
        var img = document.createElement('img');
        img.className = 'product-slider-image lazyload';
        img.style.position = 'absolute';
        img.style.top = '0';
        img.style.left = '0';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        img.style.zIndex = '5';
        // Don't set inline opacity - let CSS handle it
        img.style.transition = 'opacity 0.3s ease';
        
        img.onload = function() {
          placeholder.classList.remove('loading');
          placeholder.parentNode.insertBefore(img, placeholder);
          placeholder.dataset.loaded = 'true';
          placeholder.loadedImage = img;
          
          // Force a reflow to ensure the image is rendered before showing
          img.offsetHeight;
          
          // Use requestAnimationFrame for smoother transition
          requestAnimationFrame(function() {
            img.style.opacity = ''; // Remove inline opacity, let CSS handle it
          });
          
          resolve(img);
        };
        
        img.onerror = function() {
          placeholder.classList.remove('loading');
          reject(new Error('Failed to load image'));
        };
        
        img.src = placeholder.dataset.imageSrc;
        img.srcset = placeholder.dataset.imageSrcset;
        img.alt = placeholder.dataset.imageAlt;
        img.sizes = 'auto';
      });
    }
    
    // Show slide function with transition management
    function showSlide(index) {
      var targetSlide = allSlides[index];
      if (!targetSlide || isTransitioning) return;
      
      isTransitioning = true;
      
      if (targetSlide.classList.contains('product-slider-image-placeholder')) {
        if (targetSlide.loadedImage) {
          // Image already loaded, show it
          setActiveImage(targetSlide.loadedImage);
        } else {
          // Load the image first
          loadImage(targetSlide).then(function(img) {
            setActiveImage(img);
          }).catch(function(error) {
            console.log('Failed to load image:', error);
            isTransitioning = false;
          });
        }
      } else {
        // It's a regular image, show it directly
        setActiveImage(targetSlide);
      }
      
      // Update current slide index
      currentSlide = index;
    }
    
    // Simplified function to set active image without flickering
    function setActiveImage(targetImg) {
      // Remove active class from all images
      container.querySelectorAll('.product-slider-image').forEach(function(img) {
        img.classList.remove('active');
      });
      
      // Add active class to target image
      targetImg.classList.add('active');
      
      // Reset transition state
      setTimeout(function() {
        isTransitioning = false;
      }, 50);
    }
    
    // Previous button event listener
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        currentSlide = currentSlide > 0 ? currentSlide - 1 : allSlides.length - 1;
        showSlide(currentSlide);
      });
    }
    
    // Next button event listener
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        currentSlide = currentSlide < allSlides.length - 1 ? currentSlide + 1 : 0;
        showSlide(currentSlide);
      });
    }
  });
});